import React, { useState, useEffect } from 'react';
import axios from 'axios';


const API_URL = process.env.REACT_APP_API_URL;

const PointCostManagement = () => {
  const [pointCosts, setPointCosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editingCost, setEditingCost] = useState(null);
  const [showAddModal, setShowAddModal] = useState(false);
  const [newCost, setNewCost] = useState({
    actionName: '',
    displayName: '',
    pointCost: 5,
    description: ''
  });

  useEffect(() => {
    fetchPointCosts();
  }, []);

  const fetchPointCosts = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_URL}/api/point-costs`);
      setPointCosts(response.data);
    } catch (error) {
      console.error('Error fetching point costs:', error);
      alert('ポイントコストの取得に失敗しました');
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (pointCost) => {
    setEditingCost({ ...pointCost });
  };

  const handleSave = async () => {
    try {
      const response = await axios.put(
        `${API_URL}/api/point-costs/${editingCost.actionName}`,
        {
          pointCost: editingCost.pointCost,
          displayName: editingCost.displayName,
          description: editingCost.description
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        }
      );
      
      setPointCosts(pointCosts.map(cost => 
        cost.actionName === editingCost.actionName ? response.data : cost
      ));
      setEditingCost(null);
      alert('ポイントコストが更新されました');
    } catch (error) {
      console.error('Error updating point cost:', error);
      alert('ポイントコストの更新に失敗しました');
    }
  };

  const handleCancel = () => {
    setEditingCost(null);
  };

  const handleAdd = async () => {
    try {
      const response = await axios.post(
        `${API_URL}/api/point-costs`,
        newCost,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        }
      );
      
      setPointCosts([...pointCosts, response.data]);
      setShowAddModal(false);
      setNewCost({ actionName: '', displayName: '', pointCost: 5, description: '' });
      alert('新しいポイントコストが追加されました');
    } catch (error) {
      console.error('Error adding point cost:', error);
      alert('ポイントコストの追加に失敗しました');
    }
  };

  const handleDelete = async (actionName) => {
    if (!window.confirm('このポイントコストを削除しますか？')) {
      return;
    }

    try {
      await axios.delete(
        `${API_URL}/api/point-costs/${actionName}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        }
      );
      
      setPointCosts(pointCosts.filter(cost => cost.actionName !== actionName));
      alert('ポイントコストが削除されました');
    } catch (error) {
      console.error('Error deleting point cost:', error);
      alert('ポイントコストの削除に失敗しました');
    }
  };

  if (loading) {
    return <div>読み込み中...</div>;
  }

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <h2>ポイントコスト管理</h2>
        <button 
          onClick={() => setShowAddModal(true)}
          style={{
            padding: '10px 20px',
            backgroundColor: '#007bff',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
            display:'none'
          }}
        >
          新しいポイントコストを追加
        </button>
      </div>

      <div style={{ overflowX: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', backgroundColor: 'white' }}>
          <thead>
            <tr style={{ backgroundColor: '#f8f9fa' }}>
              <th style={{ padding: '12px', border: '1px solid #dee2e6', textAlign: 'left' }}>アクション名</th>
              <th style={{ padding: '12px', border: '1px solid #dee2e6', textAlign: 'left' }}>表示名</th>
              <th style={{ padding: '12px', border: '1px solid #dee2e6', textAlign: 'left' }}>ポイントコスト</th>
              <th style={{ padding: '12px', border: '1px solid #dee2e6', textAlign: 'left' }}>説明</th>
              <th style={{ padding: '12px', border: '1px solid #dee2e6', textAlign: 'left' }}>操作</th>
            </tr>
          </thead>
          <tbody>
            {pointCosts.map((cost) => (
              <tr key={cost.actionName}>
                <td style={{ padding: '12px', border: '1px solid #dee2e6' }}>
                  {editingCost?.actionName === cost.actionName ? (
                    <input
                      type="text"
                      value={editingCost.actionName}
                      disabled
                      style={{ width: '100%', padding: '5px' }}
                    />
                  ) : (
                    cost.actionName
                  )}
                </td>
                <td style={{ padding: '12px', border: '1px solid #dee2e6' }}>
                  {editingCost?.actionName === cost.actionName ? (
                    <input
                      type="text"
                      value={editingCost.displayName}
                      onChange={(e) => setEditingCost({...editingCost, displayName: e.target.value})}
                      style={{ width: '100%', padding: '5px' }}
                    />
                  ) : (
                    cost.displayName
                  )}
                </td>
                <td style={{ padding: '12px', border: '1px solid #dee2e6' }}>
                  {editingCost?.actionName === cost.actionName ? (
                    <input
                      type="number"
                      value={editingCost.pointCost}
                      onChange={(e) => setEditingCost({...editingCost, pointCost: parseInt(e.target.value)})}
                      style={{ width: '100%', padding: '5px' }}
                    />
                  ) : (
                    cost.pointCost
                  )}
                </td>
                <td style={{ padding: '12px', border: '1px solid #dee2e6' }}>
                  {editingCost?.actionName === cost.actionName ? (
                    <input
                      type="text"
                      value={editingCost.description}
                      onChange={(e) => setEditingCost({...editingCost, description: e.target.value})}
                      style={{ width: '100%', padding: '5px' }}
                    />
                  ) : (
                    cost.description
                  )}
                </td>
                <td style={{ padding: '12px', border: '1px solid #dee2e6' }}>
                  {editingCost?.actionName === cost.actionName ? (
                    <div>
                      <button 
                        onClick={handleSave}
                        style={{
                          marginRight: '5px',
                          padding: '5px 10px',
                          backgroundColor: '#28a745',
                          color: 'white',
                          border: 'none',
                          borderRadius: '3px',
                          cursor: 'pointer'
                        }}
                      >
                        保存
                      </button>
                      <button 
                        onClick={handleCancel}
                        style={{
                          padding: '5px 10px',
                          backgroundColor: '#6c757d',
                          color: 'white',
                          border: 'none',
                          borderRadius: '3px',
                          cursor: 'pointer'
                        }}
                      >
                        キャンセル
                      </button>
                    </div>
                  ) : (
                    <div>
                      <button 
                        onClick={() => handleEdit(cost)}
                        style={{
                          marginRight: '5px',
                          padding: '5px 10px',
                          backgroundColor: '#007bff',
                          color: 'white',
                          border: 'none',
                          borderRadius: '3px',
                          cursor: 'pointer'
                        }}
                      >
                        編集
                      </button>
                      <button 
                        onClick={() => handleDelete(cost.actionName)}
                        style={{
                          padding: '5px 10px',
                          backgroundColor: '#dc3545',
                          color: 'white',
                          border: 'none',
                          borderRadius: '3px',
                          cursor: 'pointer'
                        }}
                      >
                        削除
                      </button>
                    </div>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Add Modal */}
      {showAddModal && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0,0,0,0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1000
        }}>
          <div style={{
            backgroundColor: 'white',
            padding: '30px',
            borderRadius: '10px',
            width: '500px',
            maxWidth: '90%'
          }}>
            <h3>新しいポイントコストを追加</h3>
            <div style={{ marginBottom: '15px' }}>
              <label>アクション名:</label>
              <input
                type="text"
                value={newCost.actionName}
                onChange={(e) => setNewCost({...newCost, actionName: e.target.value})}
                style={{ width: '100%', padding: '8px', marginTop: '5px' }}
                placeholder="例: profile_view"
              />
            </div>
            <div style={{ marginBottom: '15px' }}>
              <label>表示名:</label>
              <input
                type="text"
                value={newCost.displayName}
                onChange={(e) => setNewCost({...newCost, displayName: e.target.value})}
                style={{ width: '100%', padding: '8px', marginTop: '5px' }}
                placeholder="例: プロフィール閲覧"
              />
            </div>
            <div style={{ marginBottom: '15px' }}>
              <label>ポイントコスト:</label>
              <input
                type="number"
                value={newCost.pointCost}
                onChange={(e) => setNewCost({...newCost, pointCost: parseInt(e.target.value)})}
                style={{ width: '100%', padding: '8px', marginTop: '5px' }}
              />
            </div>
            <div style={{ marginBottom: '20px' }}>
              <label>説明:</label>
              <input
                type="text"
                value={newCost.description}
                onChange={(e) => setNewCost({...newCost, description: e.target.value})}
                style={{ width: '100%', padding: '8px', marginTop: '5px' }}
                placeholder="説明を入力してください"
              />
            </div>
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
              <button 
                onClick={() => setShowAddModal(false)}
                style={{
                  padding: '10px 20px',
                  backgroundColor: '#6c757d',
                  color: 'white',
                  border: 'none',
                  borderRadius: '5px',
                  cursor: 'pointer'
                }}
              >
                キャンセル
              </button>
              <button 
                onClick={handleAdd}
                style={{
                  padding: '10px 20px',
                  backgroundColor: '#28a745',
                  color: 'white',
                  border: 'none',
                  borderRadius: '5px',
                  cursor: 'pointer'
                }}
              >
                追加
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PointCostManagement; 